<template>
  <div>
    <div
      class="row p-4"
      v-if="(orderLength <= 0)"
    >
      <p
        class="col-12 text-center"
        id="'user-no-order"
								data-test="orderProductsNoPdts"
      >
        No Products Ordered Yet
      </p>
      <br>
    </div>
    <div
      v-for="(order,key) in orders"
      class="order-item"
      :key="key"
      v-else
    >
      <h6 :id="'user-order-no-'+key"
										:data-test="'orderProductsOrderNo'+key">
        Order No:
        <a
          href=""
          class="order-number"
          style="color: #2874f0"
          @click.prevent="orderTracking(order.order_number)"
          :id="'user-order-no-link-'+key"
										:data-test="'orderProductsOrderNoLink'+key"
        >
          {{(order.order_number+'').toUpperCase()}}
        </a>
      </h6>
      <div
        class="cart-wrapper"
        v-for="(product, index) in order.orderProductDetails"
        :key="product.product_id+'_'+product.order_detail_id"
      >
        <div class="left">
          <div class="cart-items-wrapper">
            <div class="cart-item">
              <div class="cart-grid">
                <div class="cart-contents-wrapper">
                  <div class="description">
                    <router-link
                      class="cart-product-title"
                      tag="p"
                      :to="{
                            name: 'ProductDetails',
                            query:{
                              productName: product.product_name,
                              productId: product.product_id
                                   }
                                  }"
                      :id="'cart-pdt-image-'+product.product_id"
																						:data-test="'orderProductsPdtName'+index"
                    >
                      {{product.product_name}}
                    </router-link>
                    <small class="seller"
																											:data-test="'orderProductsSeller'+index"
																											:id="'orderProductsSeller'+index">
                      Seller:
                      <span :data-test="'orderProductsSellerId'+index"
																												:id="'orderProductsSellerId'+index">
                        {{product.vendor_id}}
                      </span>
                    </small>
                    <div
                      class="pricy"
                      v-if="product.promotion_id"
                    >
                      <span :data-test="'orderProductsPrmoPrice'+index"
																												:id="'orderProductsPrmoPrice'+index">
                        {{product.promotion_applied_price | currencyConversion}}
                      </span>
                      <span :data-test="'orderProductsPdtPrice'+index"
																												:id="'orderProductsPdtPrice'+index">
                        {{product.price | currencyConversion}}
                      </span>
                      <span :data-test="'orderProductsPrmoPercent'+index"
																												:id="'orderProductsPrmoPercent'+index">
                        {{product.discount_percentage}}% off
                      </span>
                    </div>
                    <div
                      class="pricy"
                      v-if="!product.promotion_id"
                    >
                      <span :data-test="'orderProductsNoPromoPrice'+index"
																												:id="'orderProductsNoPromoPrice'+index">
                        {{product.price | currencyConversion}}
                      </span>
                      <!--<span>50% off</span>-->
                    </div>
                  </div>
                </div>
                <div class="cart-image-warpper">
                  <img
                    class="cart-product-image"
                    :src="product.product_image"
                    alt="Product Image"
																				:data-test="'orderProductsPdtImg'+index"
																				:id="'orderProductsPdtImg'+index"
                  >
                  <div class="quantity-warpper">
                    <span class=""
																										:data-test="'orderProductsPdtQty'+index"
																										:id="'orderProductsPdtQty'+index">
                      Qty: {{product.quantity}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'ordered-products',
	computed: {
		...mapGetters('order', ['getTotalOrderData'])
	},
	data () {
		return {
			orders: [],
			orderLength: 0,
			showLoader: true
		}
	},
	mounted () {
		this.orders = this.getTotalOrderData.orderHistory

		this.orderLength = this.orders.length
		this.$forceUpdate()
	},
	methods: {
		orderTracking (ordNum) {
			this.$router.push({
				path: '/user/orders/orderTracking',
				query: { orderNumber: ordNum }
			})
		}
	},
	watch: {
		getTotalOrderData () {
			this.orders = this.getTotalOrderData.orderHistory

			this.orderLength = this.orders.length
			this.$forceUpdate()
		}
	}
}
</script>

<style scoped>
</style>
